module.exports = __webpack_public_path__ + "templates/about-rrss.html";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/about/templates/about-rrss.html
// module id = rH9+
// module chunks = 1